















































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {Area, AutoGroup, Dealership, SearchPath} from "@/types";
import {
    addDealership,
    deleteDealership,
    getAssociatedAutoGroup,
    getAssociatedDealershipAreas,
    getDealershipSearchPaths,
    listDealerships, searchByArea, searchByAutoGroup,
    searchByDealership, searchByDomainName, updateDealershipInformation
} from "@/endpoints";
import Search from "../utility/Search.vue";
import {buildDealershipLink} from "@/path";
import {serializeForm} from "@/util";

Vue.component("v-search", Search);

@Component
export default class Worksheet extends Vue {

    BuildDealershipLink = buildDealershipLink;
    SearchByDomainName = searchByDomainName;
    SearchByAutoGroup = searchByAutoGroup;
    SearchByDealership = searchByDealership;
    SearchByArea = searchByArea;

    submitted: boolean = false;

    loadingDealerships: boolean = false;

    currentDealershipBeingEdited: Dealership | null = null;
    currentDealershipBeingDeleted: Dealership | null = null;

    addDealershipForm : {
        dealershipName: string;
        streetAddress: string;
        latitude: string;
        longitude: string;
        isActive: boolean;
        searchPaths: SearchPath[],
        areas: Area[],
        autoGroups: AutoGroup[],
        addAreaSelectedItem: null | { id: number, name: string },
        addAutoGroupSelectedItem: null | { id: number, name: string },
    } = {
        dealershipName: "",
        streetAddress: "",
        latitude: "",
        longitude: "",
        isActive: true,
        searchPaths: [],
        areas: [],
        autoGroups: [],
        addAreaSelectedItem: null,
        addAutoGroupSelectedItem: null
    };

    addSearchPathForm: {
        selectedDomainItem: { id: number, name: string },
        searchPath: string
    } = {
        selectedDomainItem: null,
        searchPath: ""
    };

    showSearchPathForm: boolean = false;
    showDealershipAddAreaForm: boolean = false;
    showDealershipAddAutoGroupForm: boolean = false;

    availableDealerships: Dealership[] = [];

    mounted() {
        this.refreshDealershipList();
    }

    async refreshDealershipList(id?: number) {

        this.loadingDealerships = true;

        const params = new URLSearchParams();

        if(id) {
            params.append("id", `${id}`);
        }

        this.availableDealerships = await listDealerships(params.toString());

        this.loadingDealerships = false;
    }

    async onAddDealershipSubmitButtonClick() {

        this.submitted = true;

        let payload: any = {
            ...serializeForm(this.$refs['add-dealership-form'] as HTMLFormElement),
            search_paths: this.addDealershipForm.searchPaths,
            areas: this.addDealershipForm.areas,
            auto_groups: this.addDealershipForm.autoGroups
        };

        payload = JSON.stringify(payload);

        try {
            if(this.currentDealershipBeingEdited) {
                await updateDealershipInformation(payload, this.currentDealershipBeingEdited.id);
            } else {
                await addDealership(payload);
            }

            (this.$refs['add-dealership-modal'] as any).hide();

            this.refreshDealershipList();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    onDealershipResultSelected(result) {
        this.refreshDealershipList(result ? result.id : null);
    }

    onAddDealershipDeleteSearchPathButtonClick(id: number) {
        this.addDealershipForm.searchPaths = this.addDealershipForm.searchPaths.filter(path => {
            return path.domain_id !== id
        });
    }

    onAddSearchPathResultClicked(result) {
        this.addSearchPathForm.selectedDomainItem = result;
    }

    onAddDealershipDeleteAreaButtonClick(id: number) {
        this.addDealershipForm.areas = this.addDealershipForm.areas.filter((area: any) => {
            return area.id !== id
        });
    }

    onAddDealershipAutoGroupInput(result) {
        this.addDealershipForm.addAutoGroupSelectedItem = result;
    }

    onAddDealershipAreaSubmit() {
        this.addDealershipForm.areas.push(this.addDealershipForm.addAreaSelectedItem as any);
        this.addDealershipForm.addAreaSelectedItem = null;
        this.showDealershipAddAreaForm = false;
    }

    onAddSearchPathSubmissionButtonClick() {

        if(!this.isAddSearchPathFormValid) {
            return;
        }

        this.addDealershipForm.searchPaths.push({
            domain_id: this.addSearchPathForm.selectedDomainItem.id,
            host: this.addSearchPathForm.selectedDomainItem.name,
            uri: this.addSearchPathForm.searchPath
        });


        this.addSearchPathForm.searchPath = "";
        this.addSearchPathForm.selectedDomainItem = null;

        this.showSearchPathForm = false;
    }

    onAddDealershipDeleteAutoGroupButtonClick(id: number) {
        this.addDealershipForm.autoGroups = this.addDealershipForm.autoGroups.filter((group: any) => {
            return group.id !== id
        });
    }

    async onConfirmDealershipDelete() {

        this.submitted = true;

        try {
            await deleteDealership(this.currentDealershipBeingDeleted.id);

            this.refreshDealershipList();

            (this.$refs['delete-dealership-modal'] as any).hide();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    onAddDealershipAreaInput(result) {
        this.addDealershipForm.addAreaSelectedItem = result;
    }

    async onEditDealershipButtonClick(dealership: Dealership) {

        this.currentDealershipBeingEdited = dealership;

        this.addDealershipForm.dealershipName = dealership.name;
        this.addDealershipForm.streetAddress = dealership.street_address;
        this.addDealershipForm.latitude = `${dealership.latitude}`;
        this.addDealershipForm.longitude = `${dealership.longitude}`;
        this.addDealershipForm.isActive = dealership.is_active;

        (this.$refs['add-dealership-modal'] as any).show();

        this.addDealershipForm.searchPaths = await getDealershipSearchPaths(dealership.id);
        this.addDealershipForm.areas = await getAssociatedDealershipAreas(dealership.id);
        this.addDealershipForm.autoGroups = await getAssociatedAutoGroup(dealership.id);
    }

    onAddDealershipModalHidden() {
        if(this.currentDealershipBeingEdited) {
            this.currentDealershipBeingEdited = null;
        }

        this.addDealershipForm.dealershipName = "";
        this.addDealershipForm.streetAddress = "";
        this.addDealershipForm.longitude = "";
        this.addDealershipForm.latitude = "";
        this.addDealershipForm.isActive = true;
        this.addDealershipForm.searchPaths = [];
        this.addDealershipForm.areas = [];
        this.addDealershipForm.autoGroups = [];

        this.showSearchPathForm = false;
    }

    onAddDealershipAutoGroupSubmit() {
        this.addDealershipForm.autoGroups.push(this.addDealershipForm.addAutoGroupSelectedItem as any);
        this.addDealershipForm.addAutoGroupSelectedItem = null;
        this.showDealershipAddAutoGroupForm = false;
    }

    onDeleteDealershipButtonClick(dealership: Dealership) {
        this.currentDealershipBeingDeleted = dealership;
        (this.$refs['delete-dealership-modal'] as any).show();
    }

    get isAddDealershipAutoGroupFormValid() {
        return this.addDealershipForm.addAutoGroupSelectedItem !== null;
    }

    get isAddDealershipAreaFormValid() {
        return this.addDealershipForm.addAreaSelectedItem !== null;
    }

    get isAddSearchPathFormValid() {
        return this.addSearchPathForm.selectedDomainItem !== null && this.addSearchPathForm.searchPath.length
    }

    get isValidDealershipName() {
        return this.addDealershipForm.dealershipName.length > 0;
    }

    get isValidLongitude() {
        return this.addDealershipForm.longitude.length > 0 && !isNaN(parseInt(this.addDealershipForm.longitude));
    }

    get isValidLatitude() {
        return this.addDealershipForm.latitude.length > 0 && !isNaN(parseInt(this.addDealershipForm.latitude));
    }

}
